<script>
    import { createEventDispatcher } from 'svelte';
    import { trainerTools } from './trainertools.js';
    const dispatch = createEventDispatcher();
    import Swal from 'sweetalert2';
    // import Swal from 'sweetalert2';
    export let game;
    const langSelectPrefs = {
        title: 'Wybierz język',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#233e63',
        cancelButtonColor: '#941728',
        cancelButtonText: 'English',
        confirmButtonText: 'Polski',
    };

    async function selectLang() {
        let lang = await Swal.fire(langSelectPrefs);
        if (lang.isConfirmed) {
            lang = 'pl';
        } else lang = 'eng';
        return lang;
    }

    async function activateGame() {
        if (!game.isGameOn) {
            const confirmation = await Swal.fire({
                title: 'Na pewno?',
                text: 'Od tego momentu masz 3 godziny na rozgrywkę',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#233e63',
                cancelButtonColor: '#941728',
                cancelButtonText: 'Jednak nie',
                confirmButtonText: 'Tak, grajmy już!',
            });
            if (!confirmation.isConfirmed) return;
        }
        // const lang = await selectLang();
        const isSuccess = await trainerTools.activateGame(game.code);
        if (isSuccess) {
            localStorage.setItem(
                game.gameId,
                JSON.stringify({
                    key: isSuccess.data.data,
                    gamecode: game.code,
                })
            );
            const gameUrl = `https://ow.mindlab.pl/?mode=${game.gameId}`;
            window.location.assign(gameUrl);
        } else {
            console.log('incorrect activation');
        }
    }
    const credentials = JSON.parse(localStorage.getItem(game.gameId));
    // function addPlayer() {
    //     if (game.playersCount === 8) {
    //         Swal.fire('Max graczy to 8');
    //         return;
    //     }
    //     dispatch('addDeletePlayer', {
    //         gameId: game.gameId,
    //         gameCode: game.code,
    //         change: 'add',
    //     });
    // }
    // function deletePlayer() {
    //     if (game.playersCount === 4) {
    //         Swal.fire('Min graczy to 4');
    //         return;
    //     }
    //     dispatch('addDeletePlayer', {
    //         gameId: game.gameId,
    //         gameCode: game.code,
    //         change: 'delete',
    //     });
    // }
</script>

<div
    class="game"
    class:single-game={!game.isGameOn && !game.isGameEnd}
    class:running={game.isGameOn}
    class:closed={game.isGameEnd}
>
    <div class="section-bar">
        <div class="section-text">
            Gra: {game.code}
        </div>
        <hr />
    </div>
    <p class="p__game">
        Status gry: {#if game.isGameOn && !game.isGameEnd}
            Aktywna, do
            {new Date(game.validTo).toLocaleTimeString()}<br />
            {credentials && game.secretCode === credentials.key
                ? 'Aktywowana na tym urządzeniu'
                : 'Aktywowana na innym urzadzeniu'}
        {:else if game.isGameEnd}
            Zakończona
        {:else}
            Nieaktywna
        {/if}
        <br />
    </p>
    <button
        class="btn btn__smaller"
        disabled={game.isGameOn || game.isGameEnd}
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        on:click={activateGame}
        >Uruchom !
    </button>
    <button
        class="btn btn__smaller"
        class:btn--inactive={!(game.isGameOn && !game.isGameEnd)}
        disabled={!(game.isGameOn && !game.isGameEnd)}
        on:click={activateGame}
        >Kontynuuj !
    </button>
    <button
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        disabled={game.isGameOn || game.isGameEnd}
        on:click={() =>
            dispatch('deleteGame', {
                gameId: game.gameId,
                gameCode: game.code,
            })}
        >Usuń grę !
    </button>
    <!-- <button
        disabled={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        on:click={addPlayer}
        >Gracz +
    </button>
    <button
        disabled={game.isGameOn || game.isGameEnd}
        class:btn--inactive={game.isGameOn || game.isGameEnd}
        class="btn btn__smaller"
        on:click={deletePlayer}
        >Gracz -
    </button> -->
</div>
